// =============================================================================
// PlanTab - Piano e abbonamento
// =============================================================================
// Tab dedicato: il listino ha bisogno di tutta la larghezza della pagina e la
// scheda Organizzazione resta sui dati dell'azienda.
// =============================================================================

import { useTranslation } from 'react-i18next';
import { useTenantDetails } from '../../api/hooks';
import { PlansSection } from './PlansSection';
import { ErrorBlock, LoadingBlock } from './_shared';

export function PlanTab() {
  const { data: tenant, isLoading, error, refetch } = useTenantDetails();
  const { t } = useTranslation('settings');

  if (isLoading) {
    return <LoadingBlock />;
  }

  if (error || !tenant) {
    const errorMsg = (error as any)?.response?.data?.message || t('organization.loadError');
    return (
      <ErrorBlock
        title={t('organization.errorTitle')}
        message={typeof errorMsg === 'string' ? errorMsg : errorMsg[0]}
        retryLabel={t('common:buttons.retry')}
        onRetry={() => refetch()}
      />
    );
  }

  return <PlansSection tenant={tenant} />;
}
